/** @format */

export interface SmsNotification {
  list: string;
  optStatus: string;
  phoneNumber: string;
}
